import React from 'react';
import { useParams } from 'react-router-dom';

import TaskEditForm from './TaskEditForm';
import { Task } from '../../../Data/Classes';
import { NOT_DONE } from '../../../Data/Constants';

function TaskCreatePage(props) {
    const { eventId } = useParams();
    const task = new Task(0, "", "", "", 1, 1, new Date(), false, NOT_DONE, eventId);

    return (
        <>
            <h1>Feladat létrehozása</h1>
            <TaskEditForm task={task} />
        </>
    );
}

export default TaskCreatePage;
